const state = {
  menuActiveName: '', // 主菜单选中名称
  subMenuList: [], // 二级菜单列表
  subMenuWidth: 200, // 二级菜单部分宽度
  subMenuActiveName: [], // 二级菜单选中名称
  tabs: [{
    name: '首页',
    url: '/index'
  }], // tab列表
  tabActiveName: '', // 当前选中的tab
  menuList: [], // 菜单列表
  toggleMenuFromWhere: 0, // 是从哪里点击切换菜单的，0代表从一级菜单上点击，1代表从tab上点击
  userInfo: {}, // 当前用户信息
  roles: [], // 用户权限
  currentRoles: [] // 当前页面用户权限
}

export default state
